module.exports = __webpack_public_path__ + "img/co-branding-world-JET-background-1.c21dfe18.png";